import { ReactComponent as ArrowLeftIcon } from './left.svg';

export default ArrowLeftIcon;
